import { Component } from "react";
import { connect } from 'react-redux';
import HomeNav from "../components/home/HomepageNav";
import Header from "../components/home/HeroHeader";
import HomeContent from "./HomeContent";
import InnerFooter from "../components/home/InnerFooter";
import '../styles/homestyles.css';

class HomePage extends Component {
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
  static getDerivedStateFromProps(nextProps) {
    if (nextProps.logInResponse.isLoggedIn) {
      nextProps.history.push("/");
    }
  }
  handleScroll(event) {
    if (document.documentElement.scrollTop > document.querySelector(".header").scrollHeight) {
      document.querySelector(".nav").style.position = "sticky";
      document.querySelector(".nav").style.zIndex = 1000;
    }
    else {
      document.querySelector(".nav").style.position = "unset";
    }
  }
  render() {
    return (
      <div className="home">
        <HomeNav />
        <Header />
        <HomeContent />
        <InnerFooter />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  logInResponse: state.loginReducer,
})

export default connect(mapStateToProps)(HomePage);